const entities = {
  createAnEntity: 'Create an Entity',
  createAnItem: 'Create an Item',
  entities: 'Entities',
  items: 'Items',
  noEntitiesToDisplay: 'No entities to display',
  noItemsToDisplay: 'No items to display',
  xSelectedEntities_one: '{{count}} selected entity',
  xSelectedEntities_other: '{{count}} selected entities',
  xSelectedItems_one: '{{count}} selected item',
  xSelectedItems_other: '{{count}} selected items',
};

export default entities;
